export const getImageDimensions = (count: number) =>
  count > 1 ? { width: 568, height: 438 } : { width: 970, height: 747 };

export const handleImageClick = (image: { link?: string; openInNewTab?: boolean }) => {
  if (image.link) {
    if (image.openInNewTab) {
      window.open(image.link, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = image.link;
    }
  }
};
